<template>
  <div class="input-text d-block">
    <label v-if="label">{{ label }}
      <a tabindex="3" v-if="link" href="#" @click="$emit('linkAction')" style="float:right">{{link}}</a>
      <span v-if="rules.required" class="warning-color">*</span>
    </label>
    <input
      tabindex="2"
      :class="{required: shouldShowError}"
      min="0"
      :style="cssStyle"
      :placeholder="placeholder"
      :type="type"
      :value="value"
      :disabled="disabled"
      @keydown="$emit('change', $event.target.value)"
      @focus="$emit('focus')"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('blur', $event.target.value)"
      oninput="validity.valid||(value='');">
    <span v-if="shouldShowError" class="warning-color validation-span" style="font-size: 12px;">{{ $t(errorMsg) }} {{ errorMsgAdditional }}</span>
  </div>
</template>

<script>
/* eslint-disable */


import rules from "@/mixins/rules";

export default {
  mixins: [rules],
  props: {
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    cssStyle: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Date],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      default: '',
    },
  },
}
</script>
